export const EDIT_TOPIC_MODAL_I18N_PREFIX = "features.topics.components.edit_topic_modal";

export const EDIT_TOPIC_MODAL_I18N_KEYS = {
  topic_details_title:       "topic_details_title",
  close_button_text:         "close_button_text",
  upload_files_title:        "upload_files_title",
  no_uploaded_files_message: "no_uploaded_files_message"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/EditTopicModali18nConstants.js